import React from 'react'
import Icon, { IconProps } from './icon'

export type BadgeProps = {
  color?: 'primary' | 'secondary'
  icon: IconProps['icon']
}

const Badge: React.FC<BadgeProps> = ({ color = 'primary', icon }) => (
  <div className="flex flex-col items-center justify-center w-10 h-10 p-1 bg-white rounded-full">
    <Icon icon={icon} color={color} />
  </div>
)

export default Badge
